export default __webpack_public_path__ + "static/media/bf_fox_audit.baf96959.png";